import * as React from "react"
import { connect } from "react-redux"
import { GlobalState } from "../../store"

import { Symbols } from "@tenforce/toolbox-fontmap"
import env from "../../env"
import { isIE } from "../../util/UserAgent"
import { mapDispatchToProps, DispatchProps } from "./actions"
import { IBasePage } from "./index"

const applicationPath = env.applicationPath

const backgroundStyle = {
    backgroundImage:
        "linear-gradient(135deg, rgb(176, 138, 0) 0%, rgb(0, 189, 255))",
}

interface OwnProps extends React.HTMLAttributes<HTMLElement> {
    isLoading: boolean
    showRecoverPasswordUrl: boolean
}

type StateProps = IBasePage

type Props = OwnProps & StateProps & DispatchProps

export class AuthBasePage extends React.Component<Props> {
    static defaultProps: Partial<Props> = {
        showRecoverPasswordUrl: false,
        isLoading: false,
    }

    componentDidMount(): void {
        this.props.requestLogo()
    }

    render(): JSX.Element {
        const { logoUrl, isLoading, showRecoverPasswordUrl, children } =
            this.props

        return (
            <div className="tw-flex tw-flex-col sm:tw-flex-row tw-overflow-hidden">
                <div className="tw-relative tw-w-full sm:tw-w-1/2 tw-bg-white">
                    <div className="tw-flex tw-flex-col tw-justify-center tw-min-h-1/2-screen tw-h-full">
                        <div className="tw-relative tw-flex tw-justify-center tw-py-8 tw-px-1/5 is-inverted">
                            <div>
                                {/* We use the URL the backend sent to display the logo. If the call failed, we display the TF logo by default. */}
                                {/* TODO: In the future, it'd be better if the backend just sent us back the image. */}
                                {logoUrl && (
                                    <img
                                        className="tw-w-full"
                                        src={applicationPath + "/" + logoUrl}
                                        alt="Logo"
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className={`tw-relative tw-w-full sm:tw-w-1/2 ${
                        isLoading ? "is-loading" : ""
                    }`}
                >
                    <header className="sm:tw-absolute tw-top-0 tw-left-0 tw-w-full tw-text-right tw-px-8 tw-py-4">
                        {!isLoading && (
                            <a
                                href={`${applicationPath}/`}
                                className={`h4 no-underline ${
                                    isIE
                                        ? "is-inverted"
                                        : "animate-bggradienttextflow"
                                }`}
                                style={isIE ? {} : backgroundStyle}
                            >
                                {Symbols.TenForceTextLogo}
                            </a>
                        )}
                        {isLoading && (
                            <span
                                className={`h4 no-underline ${
                                    isIE
                                        ? "is-inverted"
                                        : "animate-bggradienttextflow"
                                }`}
                                style={isIE ? {} : backgroundStyle}
                            >
                                {Symbols.TenForceTextLogo}
                            </span>
                        )}
                    </header>
                    {
                        // We ensure that any child will have the necessary classes
                        React.Children.map(
                            children,
                            (child: React.ReactElement) => {
                                return React.cloneElement(child, {
                                    className:
                                        "tw-flex tw-flex-col tw-justify-center sm:tw-min-h-screen tw-p-8 tw-h-full sm:tw-py-20",
                                })
                            },
                        )
                    }
                    <footer className="sm:tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-text-right tw-px-8 tw-py-4">
                        <div
                            className={`tw-flex tw-items-center tw-justify-${
                                showRecoverPasswordUrl ? "between" : "end"
                            }`}
                        >
                            {showRecoverPasswordUrl && (
                                <p id="forgotPassword">
                                    {!isLoading && (
                                        <a
                                            href={
                                                applicationPath +
                                                "/account/lostpassword"
                                            }
                                            className="is-inverted is-dimmed"
                                        >
                                            Oh no, I forgot my password
                                        </a>
                                    )}
                                    {isLoading && (
                                        <span className="is-inverted is-dimmed is-underline">
                                            Oh no, I forgot my password
                                        </span>
                                    )}
                                </p>
                            )}
                        </div>
                    </footer>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: GlobalState): StateProps => state.auth.basePage

export default connect(mapStateToProps, mapDispatchToProps)(AuthBasePage)
